import { Category } from '@/interfaces/category.interface';
import { File } from '@/interfaces/file.interface';
import { CategoryState } from '@/interfaces/states/category-state.interface';
import { RootState } from '@/interfaces/states/root-state.interface';
import alphaSort from '@/utils/alphabetic-sort';
import sortFiles from '@/utils/sort-files';

export default {
  items: (state: CategoryState): Category[] => state.items,

  loading: (state: CategoryState): boolean => state.loading,

  rootCategories: (state: CategoryState): Category[] => {
    const { items } = state;
    return items
      .filter((item: Category) => item.parentIds.length === 0)
      .sort(({ title, positions }, { title: title2, positions: positions2 }) => {
        const pos1 = positions?.find((p) => !p.parentCategoryId)?.position?.toString() ?? 0;
        const pos2 = positions2?.find((p) => !p.parentCategoryId)?.position?.toString() ?? 0;

        const positionSort = alphaSort(pos1, pos2);
        const titleSort = alphaSort(title, title2);

        return positionSort || titleSort;
      });
  },

  subCategories: (state: CategoryState): ((id: string) => Category[]) => {
    const { items } = state;
    return (id: string): Category[] =>
      // eslint-disable-next-line implicit-arrow-linebreak
      items
        .filter((item) => item.parentIds.includes(id))
        .sort(({ title, positions }, { title: title2, positions: positions2 }) => {
          const pos1 =
            positions?.find((p) => p.parentCategoryId === +id)?.position?.toString() ?? 0;
          const pos2 =
            positions2?.find((p) => p.parentCategoryId === +id)?.position?.toString() ?? 0;

          const positionSort = alphaSort(pos1, pos2);
          const titleSort = alphaSort(title, title2);

          return positionSort || titleSort;
        });
  },

  categoryFiles: (state: CategoryState, _getters: unknown, rootState: RootState): File[] => {
    const { categoryFiles } = state;

    return sortFiles(categoryFiles, rootState);
  },

  level: (state: CategoryState): number => state.level,
};
